import {
  Dialog,
  IconButton,
  dialogClasses,
  dialogTitleClasses,
  dialogContentClasses,
  dialogActionsClasses
} from '@mui/material'
import {styled} from '@mui/material/styles'

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  position: 'absolute',
  right: 8,
  top: 8,
  color: theme.palette.common.darkGrey
}))

export const StyledDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'timelineDialog' && prop !== 'zIndexRequired'
})(({theme, timelineDialog, zIndexRequired}) => ({
  color: 'black',
  zIndex: zIndexRequired && 99999,
  [`& .${dialogClasses.paper}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    width: '100%',
    height: timelineDialog ? '' : '100%'
  },
  [`& .${dialogContentClasses.root}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black
  },
  [`& .${dialogTitleClasses.root}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black
  },
  [`& .${dialogActionsClasses.root}`]: {
    padding: '10px 22px'
  }
}))
